const REGEXP_SPECIAL_CHARS = /[!@#$%^&*(),.?":{}|<>[\]\\/'`~\-_=+]/;
const REGEXP_UPPERCASE = /[A-Z]/;

export function usePasswordValidation(password: MaybeRefOrGetter<string>) {
  const rulesPassword = computed(() => [
    {
      id: 'length',
      text: '8 or more characters',
      passed: toValue(password).length >= 8,
    },
    {
      id: 'uppercase',
      text: '1 upper case letter',
      passed: REGEXP_SPECIAL_CHARS.test(toValue(password)!),
    },
    {
      id: 'special',
      text: '1 special character',
      passed: REGEXP_UPPERCASE.test(toValue(password)!),
    },
  ]);
  const passedPasswordRules = computed(() => rulesPassword.value.filter((rule) => rule.passed).length + 1);
  const isPasswordValid = computed(() => passedPasswordRules.value === rulesPassword.value.length + 1);

  return {
    isPasswordValid,
  };
}
